import React, { useState, useEffect } from "react";
import "./Hotels.css";
import plane from "../../assets/images/home/hero-plane.svg";
import { Container, Tabs, Tab } from "react-bootstrap";
import hotel from "../../assets/images/home/hotels.svg";
import Cookies from "js-cookie";
import { useTranslation } from "../../contexts/TranslationContext";
import { useNavigate } from "react-router-dom";
import { HotelSearchBar } from "../../Features/HotelList";

const Hotels = ({ url }) => {

  const Lang = Cookies.get("preferred_language") || "en";
  const navigate = useNavigate();
  const { t } = useTranslation();

  // State for hotel search
  const [hotelSearchState, setHotelSearchState] = useState({
    destinationId: "",
    destination: "",
    checkin: "",
    checkout: "",
    travelers: "2",
    rooms: "1",
    search_type: "city",
    search_query: ""
  });
  
  const [travelers, setTravelers] = useState([
    {
      Adults: 2,
      Children: 0,
      ChildrenAges: [],
    },
  ]);

  // Handler for hotel search
  const handleHotelDiscover = () => {
  
    const params = new URLSearchParams({
      destination: hotelSearchState.destination || "Dubai, United Arab Emirates",
      checkin: hotelSearchState.checkin || "",
      checkout: hotelSearchState.checkout || "",
      travelers: JSON.stringify(travelers), 
      rooms: travelers.length.toString(),
      search_type: hotelSearchState.search_type,
      search_query: hotelSearchState.search_query,
      q: String(Date.now()),
      destinationId: hotelSearchState.destinationId || ""
    });

    navigate(`/hotels?${params.toString()}`);
  };

  return (
    <div className="hero hotel-page-container">
      <img
        src={ require("../../assets/images/home/hero.png")
        }
        alt=""
        className="hero-background hotel-page-container-bg"
      />
      <Container>
        <div className="hero-content">
          <div className="hero-desc"></div>
          <div className="hero-title">{t("BookYourHotel")}</div>
          <img
            className="hero-plane"
            data-aos="fade-down"
            data-aos-duration="1200"
            src={plane}
            alt=""
          />
          <div
            className="hero-form"
            data-aos="fade"
            data-aos-duration="1200"
            data-aos-delay="900"
          >
            <div className="hero-form-container">
              <Tabs defaultActiveKey="hotels" id="hero-tabs" className="mb-3">
                <Tab
                  eventKey="hotels"
                  title={
                    <span className="tab-title">
                      <img src={hotel} alt="Hotel" className="tab-icon" />
                      <div>{t("Hotels")}</div>
                    </span>
                  }
                >
                  {/* Hotel Search Bar */}
                  <div className="hotel-search-container">
                    <HotelSearchBar 
                      value={hotelSearchState}
                      onChange={setHotelSearchState}
                      onDiscover={handleHotelDiscover}
                      travelers={travelers}
                      onTravelersChange={setTravelers}
                    />
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Hotels;